import Link from 'next/link'
import { SafeImage } from '../../images'

export function HeaderLogo() {
  return (
    <Link href="/">
      <SafeImage priority={true} src="/imgs/layout/domeSphereLogo.webp" alt="Dome logo" height={96} width={96} />
    </Link>
  )
}
